import "twin.macro";

import { WarehouseID } from "@models/Address";

import { usePurchaseOrder } from "../context/PurchaseOrderContext";
import { useCreatePurchaseOrderVariantMutation } from "../data";
import ItemVariantInventoryQtyModal, {
  TVariantQty,
} from "./ItemVariantInventoryQtyModal";

const CreateInventoryPOVModal = ({
  itemId,
  handleClose,
  disabledSkus,
}: {
  itemId: string;
  handleClose: () => void;
  disabledSkus: string[];
}) => {
  const {
    purchaseOrder: { id },
  } = usePurchaseOrder();
  const createPurchaseOrderVariantMutation =
    useCreatePurchaseOrderVariantMutation();

  const handleCreatePOV = async (
    variantQtys: TVariantQty[],
    warehouse: string
  ) =>
    createPurchaseOrderVariantMutation.mutateAsync({
      variantQtys,
      warehouse: warehouse as WarehouseID,
      purchaseOrderId: id,
    });

  return (
    <ItemVariantInventoryQtyModal
      modalTitle="Order Additional Inventory"
      itemId={itemId}
      onClose={handleClose}
      onSubmit={handleCreatePOV}
      disabledSkus={disabledSkus}
    />
  );
};

export default CreateInventoryPOVModal;
